import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import React, { useState } from "react"
import useBrowserMode from "../../../hooks/useBrowserMode"
import Img from "gatsby-image";
import ProductService from "../../../services/products"
import SessionService from "../../../services/session"
import CheckIcon from "../../atoms/check-icon/check-icon"
import "./cardProduct.scss"
import useHomeLinkMode from '../../../hooks/useHomeLinkMode';
import ModalRetails from '../../molecules/modal-retails/modal-retails'
import { gothic, lonchmara } from '../../../_shared/Variables.scss';

const CardProduct = (props) => {

    const { homeLink } = useHomeLinkMode();
    const { isFreeSamples } = props;

    let imgProducto =
        props.producto && props.producto.imagenProductoPrevisualizacion
            ? props.producto.imagenProductoPrevisualizacion[props.ismobile ? 1 : 0]
            : { file: {} };

    let imgMuestra = props.producto && props.producto.imagenMuestraPrevisualizacion;
    // ? props.producto.imagenProductoPrevisualizacion[props.ismobile ? 1 : 0]
    // : { file: {} };
    const tempSlug = props.slug.split("/")[props.slug.split("/").length - 1];
    const newSlug = tempSlug === "articulos" ?
        props.producto.slug.split("/")[1] :
        (props.producto.slug.includes("pide-tu-muestra") || props.producto.slug.includes("muestra-gratis")) ?
            props.producto.slug.split("/")[1] : props.slug.includes("cuidadores") ? "cuidadores" : tempSlug;
    const tallas = props.producto && props.producto.talla
    const samplesFound = props.samples.filter(
        sample => sample.id === props.producto.id
    )
    const { isBrowser } = useBrowserMode()
    const filterSend = tallas
        ? (props.samplesSent &&
            props.samplesSent.filter(
                sample =>
                    tallas.includes(sample.size) && props.producto.id === sample.id
            )) ||
        []
        : []

    const isSelectedSample = tallas
        ? samplesFound.length + filterSend.length === tallas.length
        : samplesFound.length > 0
    const ctaMuestraEnviada = "MUESTRA ENVIADA"

    const renderDrops = (drops, activeDrops) => {
        let nodeArray = []
        for (let index = 0; index < Number(drops); index++) {
            nodeArray.push(
                <svg
                    key={index}
                    width="24"
                    height="35"
                    viewBox="0 0 24 35"
                >
                    <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="50%" style={{ stopColor: props.dropsColor ? props.dropsColor : gothic, stopOpacity: 1 }} />
                        <stop offset="50%" style={{ stopColor: lonchmara, stopOpacity: 1 }} />
                    </linearGradient>
                    <path
                        className={
                            index < Number(activeDrops) ? (activeDrops % 1 == 0.5 && parseInt(index + 0.5) == parseInt(activeDrops)) ? "f-drop--active-medium" : "f-drop f-drop--active" : "f-drop"
                        }
                        d="M16.68,36.747A11.919,11.919,0,0,1,5,24.586C5,15.465,16.68,2,16.68,2S28.36,15.465,28.36,24.586A11.919,11.919,0,0,1,16.68,36.747Z"
                        transform="translate(-5 -2)"
                        fill={activeDrops % 1 == 0.5 && parseInt(index + 0.5) == parseInt(activeDrops) ? "url(#grad1)" : "none"}
                    />
                </svg>
            )
        }
        return nodeArray
    }

    const [isFakeLiked, setisFakeLiked] = useState(false)
    const [isFakeUnLiked, setisFakeUnLiked] = useState(false)
    const [modalVisibility, setModalVisibility] = useState(false);
    let likeValue = props.likesInfo ? props.likesInfo.like : ""

    const formatNumber = num => {
        if (num > 999999) {
            return parseInt(num / 1000000, 10).toString() + "M"
        } else if (num > 999) {
            return parseInt(num / 1000, 10).toString() + "K"
        } else {
            return num
        }
    }

    const handleLike = () => {
        if (
            !(
                localStorage.getItem("tokenData") || sessionStorage.getItem("tokenData")
            )
        ) {
            const payloadLike = {
                type: "PRODUCTO",
                idCMS: props.idProduct,
            }
            ProductService.setAnomLikes(payloadLike).then(res => {
                if (res.status === 200) {
                    if (localStorage.getItem("LOCAL_LIKES_PRODUCTS") !== null) {
                        const copyLocalLikes = JSON.parse(
                            localStorage.getItem("LOCAL_LIKES_PRODUCTS"),
                        )
                        localStorage.setItem(
                            "LOCAL_LIKES_PRODUCTS",
                            JSON.stringify(copyLocalLikes.concat(props.idProduct))
                        )
                        props.setlocalLikes(copyLocalLikes.concat(props.idProduct))
                        isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
                    } else {
                        localStorage.setItem(
                            "LOCAL_LIKES_PRODUCTS",
                            JSON.stringify([props.idProduct])
                        )
                        props.setlocalLikes([props.idProduct])
                        isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
                    }
                } else {
                    console.log(res)
                }
            }).catch(e => console.log(e));
        } else {
            const payloadc = {
                type: "PRODUCTO",
                idCMS: props.idProduct,
            }
            const config = {
                headers: {
                    Authorization: SessionService.getIdTokenData(),
                },
            }
            ProductService.setAuthLikes(payloadc, config).then(res => {
                if (res.status === 200) {
                    if (localStorage.getItem("LOCAL_LIKES_PRODUCTS") !== null) {
                        const copyLocalLikes = JSON.parse(
                            localStorage.getItem("LOCAL_LIKES_PRODUCTS"),
                        )
                        localStorage.setItem(
                            "LOCAL_LIKES_PRODUCTS",
                            JSON.stringify(copyLocalLikes.concat(props.idProduct))
                        )
                        props.setlocalLikes(copyLocalLikes.concat(props.idProduct))
                        isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
                    } else {
                        localStorage.setItem(
                            "LOCAL_LIKES_PRODUCTS",
                            JSON.stringify([props.idProduct])
                        )
                        props.setlocalLikes([props.idProduct])
                        isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
                    }
                } else {
                    console.log(res);
                }
            }).catch(e => console.log(e));
        }
    }

    const handleUnLike = () => {
        if (
            !(
                localStorage.getItem("tokenData") || sessionStorage.getItem("tokenData")
            )
        ) {
            const payloadUnlike = {
                type: "PRODUCTO",
                idCMS: props.idProduct,
            }

            ProductService.setAnomUnLikes(payloadUnlike).then(res => {
                if (res.status === 200) {
                    const copyLocalLikes = JSON.parse(
                        localStorage.getItem("LOCAL_LIKES_PRODUCTS"),
                    )
                    localStorage.setItem(
                        "LOCAL_LIKES_PRODUCTS",
                        JSON.stringify(
                            copyLocalLikes.filter(item => item !== props.idProduct)
                        )
                    )
                    props.setlocalLikes(
                        copyLocalLikes.filter(item => item !== props.idProduct)
                    )
                    isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)
                } else {
                    console.log(res);
                }
            }).catch(e => console.log(e));
        } else {
            const payload = {
                type: "PRODUCTO",
                idCMS: props.idProduct,
            }
            const config = {
                headers: {
                    Authorization: SessionService.getIdTokenData(),
                },
            }

            ProductService.setAuthUnLikes(payload, config).then(res => {
                if (res.status === 200) {
                    const copyLocalLikes = JSON.parse(
                        localStorage.getItem("LOCAL_LIKES_PRODUCTS"),
                    )
                    localStorage.setItem(
                        "LOCAL_LIKES_PRODUCTS",
                        JSON.stringify(
                            copyLocalLikes.filter(item => item !== props.idProduct)
                        )
                    )
                    props.setlocalLikes(
                        copyLocalLikes.filter(item => item !== props.idProduct)
                    )
                    isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)
                } else {
                    console.log(res);
                }
            }).catch(e => console.log(e));
        }
    }

    const handleValidRedirect = (_event, _props) => {
        _event.preventDefault();
        !isSelectedSample && !_props.isSent && _props.actionCard ?
            _props.actionCard(_props.producto)
            :
            window.location.href = homeLink + "productos/" + _props.producto.slug;
    }

    // console.log("card", props.modeAction);
    // console.log("card", props.producto.slug);
    // console.log("card", props.slug);
    // console.log("card", (props.modeAction ? props.producto.slug : props.slug));

    return (
        <>
            {isBrowser && (
                <a
                    onClick={evt => {
                        if (props.onClick) {
                            props.onClick(evt)
                        }
                        handleValidRedirect(evt, props)
                    }}
                    href={
                        !props.modeAction
                            ? homeLink + "productos/" + props.producto.slug
                            : homeLink + props.slug
                    }
                    className={`f-card-product ${props.noFooter ? "no-footer" : ""} ${props.isSent ? "f-card-product-disabled" : ""
                        }`}
                >
                    <div
                        className={`f-card-product-header f-${newSlug} ${props.isSent ? "f-card-product-header-disabled" : ""
                            }`}
                    >
                        {isFreeSamples && imgMuestra !== null ?
                            <Img fluid={imgMuestra.fluid} alt="muestra" />
                            :
                            <Img className="f-card-product-header-img" fluid={imgProducto.fluid} alt={imgProducto.description} />
                        }
                    </div>
                    <div
                        className={`f-card-product-body ${props.noHeight ? "no-height" : ""
                            } ${props.isSent ? "f-card-product-body-disabled" : ""}`}
                    >
                        <div>
                            <label className={`f-card-product-title f-${newSlug}`}>
                                {props.producto.nombreProducto}
                            </label>
                            {!isFreeSamples &&
                                <div className="f-likes-container">
                                    {props.isLocalLiked ? (
                                        <div
                                            className="f-icon-heart"
                                            onClick={e => {
                                                handleUnLike()
                                                e.preventDefault()
                                                e.stopPropagation();
                                            }}
                                        ></div>
                                    ) : (
                                        <div
                                            className="f-icon-heart-gray"
                                            onClick={e => {
                                                handleLike()
                                                e.preventDefault()
                                                e.stopPropagation();
                                            }}
                                        ></div>
                                    )}
                                    <label className="f-count-likes">
                                        {formatNumber(
                                            isFakeLiked
                                                ? likeValue + 1
                                                : isFakeUnLiked
                                                    ? likeValue - 1
                                                    : likeValue
                                        )}
                                    </label>
                                </div>
                            }
                            <p className="f-card-product-description">
                                {props.producto.descripcionImagenProductoPrevisualizacion}
                            </p>
                        </div>
                        <div className="f-comment-container">
                            {props.producto.nivelIncontinencia && (
                                <label className="f-card-product-comment">
                                    {props.producto.nivelIncontinencia &&
                                        documentToReactComponents(
                                            props.producto.nivelIncontinencia.json
                                        )}
                                </label>
                            )}
                            <div className="f-drops-container">
                                {props.producto.numeroDeGotas &&
                                    renderDrops(
                                        props.producto.numeroDeGotas,
                                        props.producto.numeroDeGotasLlenas
                                    )}
                            </div>
                        </div>
                    </div>
                    {!props.noFooter && (
                        props.modeAction ?
                            <div
                                className={`f-card-product-footer ${props.modeAction
                                    ? isSelectedSample
                                        ? "add-selected"
                                        : "add"
                                    : ""
                                    } ${props.isSent ? "f-card-product-button-disabled" : ""}`}
                            >
                                <label className="f-btn-label-redirect">
                                    {props.isSent
                                        ? ctaMuestraEnviada
                                        : (props.modeAction &&
                                            props.modeAction[isSelectedSample ? 1 : 0]) ||
                                        props.producto.ctaSaberMas}
                                </label>
                                {props.modeAction && !props.isSent && (
                                    <CheckIcon checked={isSelectedSample} />
                                )}
                            </div>
                            :
                            <div className="f-card-product-footer f-product-buttons">
                                <div className="f-product-buttons__button f-product-buttons__button--primary">
                                    {props.producto.ctaSaberMas}
                                </div>

                                <button
                                    className="f-product-buttons__button f-product-buttons__button--secondary"
                                    onClick={e => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        if (props.setModalShop) {
                                            props.setModalShop(true)
                                        } else {
                                            setModalVisibility(true)
                                        }
                                    }}
                                >
                                    IR A COMPRAR
                                </button>
                            </div>
                    )}
                </a>
            )}

            {modalVisibility &&
                <ModalRetails
                    productInfo={props.producto}
                    paramRetails={props.producto.retailsDelProducto}
                    hideAction={() => {
                        setModalVisibility(false)
                    }}
                />
            }

        </>
    )
}

export default CardProduct;
